import {signIn} from "next-auth/react";
import {isJsonString} from "./isJsonString";

export const goUnderUser = async ({user_id, accessToken, local = 'ru', under_type = 'under'}) => {
    const callbackUrl = '/'

    return await signIn('credentials',
        {
            user_id,
            type: 'under-user',
            under_type,
            accessToken,
            local,
            redirect: false,
        }
    ).then((resp)=>{
        if (resp.error){
            if (isJsonString(resp.error)){
                const er = JSON.parse(resp.error)
                console.log(er)
                //alert(er.message, 'error')
            } else {
                //alert(resp.error, 'error')
            }
        }else {
            window.location.href = callbackUrl
        }
    })
}